export const smartDocStaticParamType_SmartMDM = 'smart-mdm';
//# sourceMappingURL=types.js.map